let getAccessTokenSilently: any = null;

export const sec = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: (func: Function) => (getAccessTokenSilently = func),
};
